import { Expose, Type } from "class-transformer";
import { PersonaDto } from "../../../persona/dto/persona/persona.dto";
import type { IPersonaDto } from "../../../persona/dto/persona/persona.dto.interface";
import { HouseholdMemberRelationshipDto } from "../../../../../legacy/services/household/dtos/household-member-relationship/household-member-relationship.dto";
import type { IHouseholdMemberRelationshipDto } from "../../../../../legacy/services/household/dtos/household-member-relationship/household-member-relationship.dto.interface";
import type { IHouseholdMemberPersonaDto } from "./household-member-persona.dto.interface";

export class HouseholdMemberPersonaDto implements IHouseholdMemberPersonaDto {
  @Expose()
  @Type(() => PersonaDto)
  persona!: IPersonaDto;

  @Expose()
  @Type(() => HouseholdMemberRelationshipDto)
  relationship!: IHouseholdMemberRelationshipDto;
}
